var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirection2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250 250",
    style: {
      enableBackground: "new 0 0 250 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:url(#SVGID_1_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st1{fill:none;stroke:url(#SVGID_00000181771865786377945050000004373015196478488497_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st2{fill:none;stroke:url(#SVGID_00000119815454606849889220000007020991118262731192_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st3{fill:none;stroke:url(#SVGID_00000091733318480592204550000000645184453809480873_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st4{fill:none;stroke:url(#SVGID_00000112617954439267792550000006990537361302180253_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st5{fill:none;stroke:url(#SVGID_00000178192887930023762520000008299852680084176817_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st6{fill:none;stroke:url(#SVGID_00000009573724826670515610000001933358709667624325_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st7{fill:none;stroke:url(#SVGID_00000105406772153506600360000001992037885578911626_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st8{fill:none;stroke:url(#SVGID_00000003802821565584629460000017542010472396888468_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st9{fill:none;stroke:url(#SVGID_00000141430563995843642770000010867274760449043590_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st10{fill:none;stroke:url(#SVGID_00000147209255965863964670000005698839786860004505_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st11{fill:none;stroke:url(#SVGID_00000076574992748041020090000007353006782158511745_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st12{fill:none;stroke:url(#SVGID_00000007425172361173770600000015084130321359873424_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st13{fill:none;stroke:url(#SVGID_00000134230625490769505230000005175358268919180966_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st14{fill:none;stroke:url(#SVGID_00000049223668700633082380000006073636185039074180_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st15{fill:none;stroke:url(#SVGID_00000165197758803640720360000003861296268877466043_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st16{fill:none;stroke:url(#SVGID_00000178920543795694020510000000779194576715750301_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st17{fill:none;stroke:url(#SVGID_00000094578025507888441170000010438733053369374631_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st18{fill:none;stroke:url(#SVGID_00000070078422331460418380000003268634280142672018_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st19{fill:none;stroke:url(#SVGID_00000042000495603912260280000014403033702768038546_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st20{fill:none;stroke:url(#SVGID_00000008122971102819174190000008014270253909032841_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st21{fill:none;stroke:url(#SVGID_00000112620621395483626560000005964518385566713763_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st22{fill:none;stroke:url(#SVGID_00000060743657369489134460000014081385190264373679_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st23{fill:none;stroke:url(#SVGID_00000039135345884366996590000012471544001782083477_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st24{fill:none;stroke:url(#SVGID_00000160884415779207353490000013983044294173834929_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st25{fill:none;stroke:url(#SVGID_00000069361934398679324160000007307347577945107115_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st26{fill:none;stroke:url(#SVGID_00000167398175337452020840000011031535289891179662_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st27{fill:none;stroke:url(#SVGID_00000054950702035287750180000003834574559611190967_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st28{fill:none;stroke:url(#SVGID_00000065040262414781069060000017142606153192644781_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st29{fill:none;stroke:url(#SVGID_00000151505038261896133990000015046569240646145415_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st30{fill:none;stroke:url(#SVGID_00000051362313079763997440000017232626965023612584_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st31{fill:none;stroke:url(#SVGID_00000074422467305243327210000000574667343816729478_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st32{fill:none;stroke:url(#SVGID_00000180348822667486957810000002455499779535431589_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st33{fill:none;stroke:url(#SVGID_00000176728850282339551850000017972211312511702172_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st34{fill:none;stroke:url(#SVGID_00000016060763461829009940000011627256305488177796_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st35{fill:none;stroke:url(#SVGID_00000148644385320918850370000017790174357496650129_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st36{fill:none;stroke:url(#SVGID_00000085966217534577225750000018061077366310213505_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st37{fill:none;stroke:url(#SVGID_00000027601580824280405790000010800056998356944036_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st38{fill:none;stroke:url(#SVGID_00000176745136109245336490000009736743310278336444_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st39{fill:none;stroke:url(#SVGID_00000040546942949827869830000009579347811619778217_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st40{fill:none;stroke:url(#SVGID_00000121961420691183281040000005624960059313290628_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st41{fill:none;stroke:url(#SVGID_00000020372932404696105250000016426796556058741632_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st42{fill:none;stroke:url(#SVGID_00000078767480122535628070000007747398839912887427_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st43{fill:none;stroke:url(#SVGID_00000009587592023760278390000009328040813987345320_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st44{fill:none;stroke:url(#SVGID_00000079482414307546416480000007086848048861195941_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st45{fill:none;stroke:url(#SVGID_00000161610647353429978640000005206806850225278616_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st46{fill:none;stroke:url(#SVGID_00000104684648397713465820000006603424399958016957_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st47{fill:none;stroke:url(#SVGID_00000036241895336813133230000004299440880236228250_);stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 87.9119,
    y1: 235.8406,
    x2: 87.9119,
    y2: 147.9238
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00E2B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    style: {
      stopColor: "#00E0B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4685,
    style: {
      stopColor: "#00D9C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7664,
    style: {
      stopColor: "#00CEE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C3FD"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.04,150.92h123.73c0,38.86-21.03,69.02-51.1,81.92H54.14c-30.07-12.9-51.09-43.06-51.09-81.92h10.36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000038411844496832766730000014962933289671927962_",
    gradientUnits: "userSpaceOnUse",
    x1: 87.9097,
    y1: 247.6931,
    x2: 87.9097,
    y2: 229.8406
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00E2B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    style: {
      stopColor: "#00E0B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4685,
    style: {
      stopColor: "#00D9C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7664,
    style: {
      stopColor: "#00CEE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C3FD"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 54.14,
    y: 232.84,
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000038411844496832766730000014962933289671927962_)",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 67.53,
    height: 11.85
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151519701218028622020000003611188586766646427_",
    gradientUnits: "userSpaceOnUse",
    x1: 132.6749,
    y1: 175.9473,
    x2: 132.6749,
    y2: 169.9473
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00E2B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    style: {
      stopColor: "#00E0B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4685,
    style: {
      stopColor: "#00D9C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7664,
    style: {
      stopColor: "#00CEE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C3FD"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000151519701218028622020000003611188586766646427_)",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 170.51,
    y1: 172.95,
    x2: 94.84,
    y2: 172.95
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153668930766802984020000009018351097749925821_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.0033,
    y1: 247.6954,
    x2: 35.0033,
    y2: 241.6954
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00E2B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    style: {
      stopColor: "#00E0B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4685,
    style: {
      stopColor: "#00D9C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7664,
    style: {
      stopColor: "#00CEE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C3FD"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000153668930766802984020000009018351097749925821_)",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 54.15,
    y1: 244.7,
    x2: 15.86,
    y2: 244.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142871560657836387790000011053749227027819451_",
    gradientUnits: "userSpaceOnUse",
    x1: 143.1573,
    y1: 247.6954,
    x2: 143.1573,
    y2: 241.6954
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00E2B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    style: {
      stopColor: "#00E0B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4685,
    style: {
      stopColor: "#00D9C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7664,
    style: {
      stopColor: "#00CEE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C3FD"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000142871560657836387790000011053749227027819451_)",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 164.64,
    y1: 244.7,
    x2: 121.67,
    y2: 244.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101808073652999681700000000182059046323824788_",
    gradientUnits: "userSpaceOnUse",
    x1: 140.0374,
    y1: 78.1217,
    x2: 140.0374,
    y2: 33.3106
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00E2B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    style: {
      stopColor: "#00E0B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4685,
    style: {
      stopColor: "#00D9C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7664,
    style: {
      stopColor: "#00CEE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C3FD"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000101808073652999681700000000182059046323824788_)",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 159.44,
    y1: 36.31,
    x2: 120.63,
    y2: 75.12
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124121762839975160700000001193046717216547758_",
    gradientUnits: "userSpaceOnUse",
    x1: 203.7917,
    y1: 72.5792,
    x2: 203.7917,
    y2: 66.5421
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00E2B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    style: {
      stopColor: "#00E0B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4685,
    style: {
      stopColor: "#00D9C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7664,
    style: {
      stopColor: "#00CEE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C3FD"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000124121762839975160700000001193046717216547758_)",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 203.82,
    y1: 69.58,
    x2: 203.77,
    y2: 69.54
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036223388006378078310000017837987629030145204_",
    gradientUnits: "userSpaceOnUse",
    x1: 173.6857,
    y1: 137.2396,
    x2: 173.6857,
    y2: 33.3126
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00E2B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    style: {
      stopColor: "#00E0B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4685,
    style: {
      stopColor: "#00D9C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7664,
    style: {
      stopColor: "#00CEE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C3FD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000036223388006378078310000017837987629030145204_)",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M237.31,107.28L237.31,107.28l-3.59-15.18c0,0-14.03-10.58-29.91-22.53l-0.05-0.04c-10.17-7.66-21.09-15.87-29.55-22.21 c-8.62-6.47-14.68-11-14.77-11.01l-38.81,38.81l-0.02,0.03L110.06,85.7l21.59,4.2c6.33,8.44,14.52,19.32,22.16,29.47 c0,0.01,0.01,0.01,0.02,0.02c3.99,5.3,7.83,10.4,11.17,14.85"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161627547458217752290000008663906004677507722_",
    gradientUnits: "userSpaceOnUse",
    x1: 135.2164,
    y1: 74.9974,
    x2: 135.2164,
    y2: 33.4233
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00E2B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    style: {
      stopColor: "#00E0B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4685,
    style: {
      stopColor: "#00D9C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7664,
    style: {
      stopColor: "#00CEE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C3FD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000161627547458217752290000008663906004677507722_)",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M117.46,72c-0.09-2.13,0.01-4.52,0.47-7.09c1.36-7.64,5.24-13.39,8.63-17.19l2.16-2.16c3.8-3.39,9.55-7.27,17.19-8.63 c2.57-0.46,4.96-0.56,7.09-0.47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000087412774940143590180000000759965032115369387_",
    gradientUnits: "userSpaceOnUse",
    x1: 228.7983,
    y1: 137.2396,
    x2: 228.7983,
    y2: 104.2798
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00E2B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    style: {
      stopColor: "#00E0B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4685,
    style: {
      stopColor: "#00D9C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7664,
    style: {
      stopColor: "#00CEE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C3FD"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000087412774940143590180000000759965032115369387_)",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 216.97,134.24 240.62,110.59 237.31,107.28 237.31,107.28  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025434908770678468420000012417419806110283955_",
    gradientUnits: "userSpaceOnUse",
    x1: 212.7454,
    y1: 137.2396,
    x2: 212.7454,
    y2: 89.4021
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00E2B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    style: {
      stopColor: "#00E0B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4685,
    style: {
      stopColor: "#00D9C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7664,
    style: {
      stopColor: "#00CEE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C3FD"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000025434908770678468420000012417419806110283955_)",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 233.9,
    y1: 92.4,
    x2: 191.59,
    y2: 134.24
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027587475764260674620000003655582800701392317_",
    gradientUnits: "userSpaceOnUse",
    x1: 175.1617,
    y1: 116.7667,
    x2: 175.1617,
    y2: 65.0979
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00E2B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    style: {
      stopColor: "#00E0B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4685,
    style: {
      stopColor: "#00D9C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7664,
    style: {
      stopColor: "#00CEE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C3FD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000027587475764260674620000003655582800701392317_)",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M163.64,70.03l32.42,32.42c2.58,2.58,2.58,6.8,0,9.38c-2.58,2.58-6.8,2.58-9.38,0l-32.42-32.42c-2.58-2.58-2.58-6.8,0-9.38 c1.29-1.29,2.99-1.93,4.69-1.93C160.65,68.1,162.35,68.74,163.64,70.03z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179621347057720870850000004132862827132279470_",
    gradientUnits: "userSpaceOnUse",
    x1: 185.3399,
    y1: 55.7881,
    x2: 185.3399,
    y2: 25.4
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00E2B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    style: {
      stopColor: "#00E0B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4685,
    style: {
      stopColor: "#00D9C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7664,
    style: {
      stopColor: "#00CEE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C3FD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000179621347057720870850000004132862827132279470_)",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M159.44,36.31l4.87-4.87c3.5-3.5,8.99-4.04,13.11-1.29l33.81,22.63"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155835333847651807870000003069992805946094727_",
    gradientUnits: "userSpaceOnUse",
    x1: 109.0437,
    y1: 108.4015,
    x2: 109.0437,
    y2: 89.5113
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00E2B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    style: {
      stopColor: "#00E0B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4685,
    style: {
      stopColor: "#00D9C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7664,
    style: {
      stopColor: "#00CEE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C3FD"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000155835333847651807870000003069992805946094727_)",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 109.04,
    y1: 92.51,
    x2: 109.04,
    y2: 105.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034791225791960351120000015076877745008426943_",
    gradientUnits: "userSpaceOnUse",
    x1: 109.0437,
    y1: 130.9045,
    x2: 109.0437,
    y2: 112.0145
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00E2B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    style: {
      stopColor: "#00E0B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4685,
    style: {
      stopColor: "#00D9C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7664,
    style: {
      stopColor: "#00CEE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C3FD"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000034791225791960351120000015076877745008426943_)",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 109.04,
    y1: 115.01,
    x2: 109.04,
    y2: 127.9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145737835871964204690000015072587299075680936_",
    gradientUnits: "userSpaceOnUse",
    x1: 191.3944,
    y1: 220.2996,
    x2: 191.3944,
    y2: 159.0795
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00E2B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    style: {
      stopColor: "#00E0B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4685,
    style: {
      stopColor: "#00D9C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7664,
    style: {
      stopColor: "#00CEE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C3FD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000145737835871964204690000015072587299075680936_)",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M174.83,162.08h18.22c8.23,0,14.9,6.67,14.9,14.9v0c0,8.23-6.67,14.9-14.9,14.9h-3.32c-8.23,0-14.9,6.67-14.9,14.9v10.52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirection2);
export default __webpack_public_path__ + "static/media/Direction_2.3f11c561052a203fc287126f85ae4627.svg";
export { ForwardRef as ReactComponent };